/**
 * A noop padding strategy.
 */
export const NoPadding = {
  pad() {
  },

  unpad() {
  },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/crypto-es/lib/pad-nopadding.js
// module id = null
// module chunks = 